module.exports = __webpack_public_path__ + "static/media/diy-roof.8d04b2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/diy-roof.png
// module id = 876
// module chunks = 1